<template>
  <filter-summary
    icon="customers"
    title="顧客コードリスト"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ filename }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 顧客コードリストの分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    filename: String,
    errors: {
      type: Array,
    },
  },
}
</script>
